import { MenuSelector } from './MenuSelector';
import { MenuScrollBehavior } from './MenuScrollBehavior';

class MenuSyndicated {
  constructor() {
    this.MenuScrollBehavior = new MenuScrollBehavior();
    this.MenuSelectorObject = new MenuSelector(this.MenuScrollBehavior);
  }

  listeners = () => {
    document.addEventListener('DOMContentLoaded', this.menuSyndicateCallback);
    window.addEventListener('resize', this.menuSyndicateCallback);
  };

  menuSyndicateCallback = () => {
    this.MenuSelectorObject.init();

    setTimeout(() => {
      this.MenuScrollBehavior.init();
    }, 100);
  };
}

const MenuSyndicatedObject = new MenuSyndicated();
MenuSyndicatedObject.listeners();
